import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const getToggleButtonStylings = (selected) => ({
  textTransform: "capitalize",
  padding: "0px 6px",
  fontSize: "12px",
  color: selected ? "#fff" : "#566875",
  border: selected ? "1px solid #0C80F3" : undefined,
  backgroundColor: selected ? "#0C80F3" : "inherit",
  "&.Mui-selected": {
    backgroundColor: "#0C80F3",
    color: "#fff",
    border: "1px solid #0C80F3",
    "&:hover": {
      backgroundColor: "#0C80F3",
    },
  },
});

const ToggleButtonsGroupUI = ({
  aggregationOptions,
  aggregationView,
  aggregationViewHandler,
}) => {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={aggregationView}
      onChange={aggregationViewHandler}
      aria-label="aggregation"
    >
      {aggregationOptions?.map((item, index) => (
        <ToggleButton
          key={index}
          value={item?.value}
          aria-label={item?.value}
          sx={getToggleButtonStylings(aggregationView === item?.value)}
        >
          {item?.title}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ToggleButtonsGroupUI;
